import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { ErrorReportService } from 'src/services/error-report.service';
import { HttpService } from 'src/services/http.service';
import { OneSignalService } from 'src/services/onesignal.service';

// Interface para definir a estrutura de uma notificação
interface Notification {
  id: string;
  title: string;
  message: string;
  data: string;
}

@Component({
  selector: 'app-send-notification',
  templateUrl: './send-notification.component.html',
  styleUrls: ['./send-notification.component.scss']
})
export class SendNotificationComponent implements OnInit {

  form: FormGroup;
  dataSource = new MatTableDataSource<Notification>(); // Definindo o dataSource
  displayedColumns: string[] = ['title', 'message', 'data']; // Colunas da tabela

  @ViewChild(MatPaginator) paginator: MatPaginator; // Referência ao MatPaginator

  constructor(
    fb: FormBuilder,
    private oneSignalService: OneSignalService,
    private http: HttpService,
    private errorReport: ErrorReportService,
    private snackbar: MatSnackBar,
  ) { 
    
    this.form = fb.group({
      title: [null, Validators.required],
      message: [null, Validators.required]
    })
  }

  ngOnInit(): void {
    this.loadNotifications(); 
  }

  submit(){
    
    const isValid = !this.form.invalid;
    const data = this.form.getRawValue();

    if (isValid) {

    this.http.get('onsignal:getAllUser')
      .subscribe(
        (result: any) => {
          if (result.type === 'OK') {
            const users = result.data; // Array de usuários
            const signatureIds = users.map(user => user.signature_id); // Extrai os signature_ids
            const notification_for_all = 'true';
        
            // Envia os dados para a função do backend que lida com as notificações
            this.oneSignalService.sendNotification(signatureIds, data.title, data.message, notification_for_all)
            .subscribe(
              (result: any) => {
                if (result.type === 'OK') {
                  this.snackbar.open('Notificação Enviada com Sucesso', 'OK', { duration: 2000 });
                  this.oneSignalService.listNotification();
                  this.loadNotifications();
                  this.form.reset();
                } else {
                  console.error('Erro ao enviar notificação');
                  this.snackbar.open('Ops, Ocorreu um erro. Tente novamente mais tarde', 'OK', { duration: 2000 });
                }
              },
              err => {
                console.error('Erro ao enviar notificação', err);
                this.errorReport.showMessage(err);
              }
            );
          } else {
            console.error('Erro ao obter dados');
          }
        },
        err => this.errorReport.showMessage(err)
      )
    }  
  
  }

  // Função para carregar as notificações do backend
  loadNotifications() {
    this.http.get('onsignal:getNoficationToAll')
      .subscribe(
        (result: any) => {
          if (result.type === 'OK') {
          this.dataSource.data = result.data; // Define os dados no dataSource
          this.dataSource.paginator = this.paginator; // Configura a paginação
        }
      },
      err => {
        console.error('Erro ao carregar notificações', err);
        this.errorReport.showMessage(err);
      }
    );
  }

}
